import { Payment } from '../../../store/payment/api/interface';
import { formatDate } from '../../../utils/formatTime';

export function csv(data: Payment[]) {
  const result = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    result.push({
      number: element?.advertiseNumber,
      title: element?.title,
      package: element?.payments?.[0]?.advertise_package?.labelEn ?? '-',
      user: element?.createdByUser?.name,
      date: element?.payments?.[0]?.paymentDate ? formatDate(element?.payments?.[0]?.paymentDate) : '-',
      amount: element?.payments?.[0]?.paymentAmount ? `QAR ${element?.payments?.[0]?.paymentAmount}` : '-',
      status: element?.payments?.[0]?.paymentStatus === 'pending' ? 'Un-Paid' : element?.payments?.[0]?.paymentStatus,
      address: `${element?.address},Building Number: ${element?.buildingNumber ?? ''}, Street Number: ${element?.streetNumber ?? ''}, Zone Number: ${element?.zoneNumber ?? ''}, Zip Code: ${element?.zipCode ?? ''}.`,
    });
  }

  return result;
}